<template>
  <div id="days-selection">
    <div id="title">
      {{ $ts('toursSettings.common.daysAvailable') }}
    </div>

    <div
      id="days-row"
      class="d-flex justify-content-between"
    >
      <div
        v-for="(day, idx) in days"
        :id="`${idx}-day`"
        :key="idx"
        :class="`day-box d-flex justify-content-center align-items-center ${day.selected ? 'selected' : ''}`"
        @click="handleDayClicked(day)"
      >
        <span>
          {{ $ts(`toursSettings.common.${day.value}Initial`) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ISelectOption } from '@/shared';

export default defineComponent({
  name: 'RsDaysSelection',
  props: {
    value: {
      type: Array as PropType<ISelectOption[]>,
      default: () => [],
    },
  },
  data() {
    return {
      days: [
        {
          value: 'sunday',
          text: 'S',
          selected: false,
        },
        {
          value: 'monday',
          text: 'M',
          selected: false,
        }, {
          value: 'tuesday',
          text: 'T',
          selected: false,
        }, {
          value: 'wednesday',
          text: 'W',
          selected: false,
        }, {
          value: 'thursday',
          text: 'T',
          selected: false,
        }, {
          value: 'friday',
          text: 'F',
          selected: false,
        },
        {
          value: 'saturday',
          text: 'S',
          selected: false,
        } ] as ISelectOption[],
    };
  },
  computed: {
    selectedDays(): ISelectOption[] {
      return this.days.filter((d: ISelectOption) => d.selected);
    },
  },
  watch: {
    value() {
      this.value.forEach((day) => {
        const lookupDay = this.days.find((searchDay) => searchDay.value === day.value);
        lookupDay!!.selected = day.selected;
      });
    },
  },
  methods: {
    handleDayClicked(day: ISelectOption) {
      day.selected = !day.selected;
      this.$emit('input', this.selectedDays);
    },
  },
});

</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';
#days-selection {
  width: 274px;
  height: 64px;
}

#title {
  color: $secondary-color-dark;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 11px;
}

.day-box {
  width: 34px;
  height: 34px;
  background-color: #C9CCDF;
  color: $secondary-color-dark;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
}

.selected {
  color: #fff;
  background-color: $secondary-color;
}

</style>
